import { useQuery } from "@tanstack/react-query";
import { Ibge } from "../../../../services/Ibge";

export const useUfs = () => {
  return useQuery({
    queryKey: ["ibge-ufs"],
    queryFn: () => Ibge.UFs(),
    select: (response) => response.data,
  });
};
